import React from 'react';

/**
 * FormSection
 * Enterprise section header with icon, accent color, and clean border divider.
 * Matches AgentCreate.jsx pattern from D:\Shipment\Mahadhav\reactapp.
 */
export const FormSection = ({
  icon,
  iconColor = '#4287f5',
  title,
  children,
  style = {}
}) => {
  return (
    <div style={{ marginBottom: '2rem', ...style }}>
      <div
        className="form-section-header"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.6rem',
          marginBottom: '1.25rem',
          paddingBottom: '0.75rem',
          borderBottom: '1px solid var(--border-color)',
          color: iconColor
        }}
      >
        {icon && (
          <span className="form-section-icon" style={{ display: 'flex', alignItems: 'center' }}>
            {icon}
          </span>
        )}
        <h3
          className="form-section-title"
          style={{
            margin: 0,
            fontSize: '1.05rem',
            fontWeight: 600,
            color: 'var(--text-primary)'
          }}
        >
          {title}
        </h3>
      </div>
      {children}
    </div>
  );
};

export default FormSection;
